export const columnsBranch = [
    {
      Header: "ID",
      accessor: "id",
    },
    {
      Header: "BRANCH NAME",
      accessor: "name_branch",
    },
    {
      Header: "UPDATE",
      accessor: "update",
    },
    {
      Header: "DELETE",
      accessor: "delete",
    },
  ];
  